import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { OverzichtComponent } from './overzicht/overzicht.component';
import { BerichtDetailComponent } from './bericht-detail/bericht-detail.component';
import { BerichtThumbnailComponent } from './overzicht/bericht-thumbnail/bericht-thumbnail.component';
import { FooterComponent } from './shared/footer/footer.component';
import { BerichtFormComponent } from './bericht-form/bericht-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { AngularFireStorageModule } from '@angular/fire/storage';

@NgModule({
            declarations: [
              AppComponent,
              HeaderComponent,
              OverzichtComponent,
              BerichtDetailComponent,
              BerichtThumbnailComponent,
              FooterComponent,
              BerichtFormComponent
            ],
            imports: [
              BrowserModule,
              AppRoutingModule,
              ReactiveFormsModule,
              AngularFireModule.initializeApp(environment.firebaseConfig),
              AngularFirestoreModule,
              AngularFireStorageModule,
            ],
            providers: [],
            bootstrap: [AppComponent]
          })
export class AppModule {
}
